export const PERIODS = [
    { value: "years" },
    { value: "quarters" },
    { value: "months" },
    { value: "weeks" },
    { value: "days" }
];

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;